var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalanderEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 249,
  height: 100,
  viewBox: "0 0 249 100",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E3E0FF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M146.346 0c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h55.112c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h37.037c5.526 0 10.005 4.477 10.005 10s-4.48 10-10.005 10h-32.75c-5.525 0-10.004 4.477-10.004 10s4.479 10 10.004 10h2.05c5.525 0 10.005 4.477 10.005 10s-4.48 10-10.005 10H54.13c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10H35.682c-5.526 0-10.005-4.477-10.005-10s4.48-10 10.005-10h19.877c5.526 0 10.005-4.477 10.005-10s-4.48-10-10.005-10H10.505C4.979 40 .5 35.523.5 30s4.48-10 10.005-10h66.493c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10h69.348zm88.635 80.374c5.407 0 9.79 4.393 9.79 9.813 0 5.42-4.383 9.813-9.79 9.813-5.406 0-9.789-4.393-9.789-9.813 0-5.42 4.383-9.813 9.79-9.813z",
  transform: "translate(-63 -233) translate(63 233) matrix(-1 0 0 1 249 0)"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalanderEmpty);
export default ForwardRef;